export function deCodeOccupancies(
  slug: string,
): { adults: number; children: number[]; infants?: number[] }[] {
  return slug.split("__").map((roomData) => {
    const decodedRoomData = decodeURIComponent(roomData);

    const adultsMatch = decodedRoomData.match(/a(\d+)/);
    const childrenMatch = decodedRoomData.match(/c([^\i]*)/); // capture everything between 'c' and 'i' or end
    const infantsMatch = decodedRoomData.match(/i(\d+(?:_\d+)*)/); // matches i1_2 or i3

    if (adultsMatch) {
      const adults = parseInt(adultsMatch[1], 10);

      const children = childrenMatch
        ? childrenMatch[1] === "-1"
          ? []
          : childrenMatch[1].split("_").map(Number)
        : [];

      const infants = infantsMatch
        ? infantsMatch[1].split("_").map(Number)
        : undefined;

      return infants !== undefined
        ? { adults, children, infants }
        : { adults, children };
    } else {
      return { adults: 0, children: [] };
    }
  });
}
